import service from "@/utils/axios";

/**
 * @description 分页查询协议列表
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {number} [params.privacyType] - 协议类型（0-用户协议，1-隐私政策，2-Cookie政策）
 * @returns {Promise} - 响应结果
 */
export const getPolicyList = (params) => service.get('/system/userPrivacy/list', { params });

/**
 * @description 根据ID查询协议详情
 * @param {number} params.id - 协议ID
 * @returns {Promise} - 响应结果
 */
export const getPolicyDetail = (params) => service.get(`/system/userPrivacy/detail/${params.id}`);

/**
 * @description 根据语言和类型查询协议详情
 * @param {Object} params - 查询参数
 * @param {string} params.lan - 语言（zh、en、ja等）
 * @param {number} params.privacyType - 协议类型（0-用户协议，1-隐私政策，2-Cookie政策）
 * @returns {Promise} - 响应结果
 */
export const getPolicyDetailByLanAndType = (params) => service.get('/system/userPrivacy/detailByLanAndType', { params });

/**
 * @description 新增协议
 * @param {Object} params - 协议参数
 * @param {string} params.lan - 语言（zh、en、ja等）
 * @param {string} params.content - 协议内容（HTML格式）
 * @param {number} params.privacyType - 协议类型（0-用户协议，1-隐私政策，2-Cookie政策）
 * @returns {Promise} - 响应结果
 */
export const addPolicy = (params) => service.post('/system/userPrivacy/add', params, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * @description 修改协议
 * @param {Object} params - 协议参数
 * @param {number} params.id - 协议ID
 * @param {string} params.lan - 语言（zh、en、ja等）
 * @param {string} params.content - 协议内容（HTML格式）
 * @param {number} params.privacyType - 协议类型（0-用户协议，1-隐私政策，2-Cookie政策）
 * @returns {Promise} - 响应结果
 */
export const updatePolicy = (params) => service.post('/system/userPrivacy/update', params, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
